"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3769],{

/***/ 3769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* reexport */ extreme_upgrade_ExtremeUpgradeModal; }
});

// UNUSED EXPORTS: EXTREME_UPGRADE_FLAT_ICONS, EXTREME_UPGRADE_GROUPS

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js + 5 modules
var spin = __webpack_require__(57381);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./src/constants/extremeUpgrade.js
var extremeUpgrade = __webpack_require__(76919);
// EXTERNAL MODULE: ./src/utils/subscriptionStatus.js
var subscriptionStatus = __webpack_require__(38365);
;// CONCATENATED MODULE: ./src/@core/components/modal/extreme-upgrade/extremeUpgradeSupport.js
// The upgrade guide is rendered before a device dashboard is fully available.
// Keep these presentation assets local instead of depending on environment
// variables, otherwise the modal falls back to empty placeholders when an
// icon variable is absent from a deployment environment.
const icon = (name, file)=>({
        name,
        img: file.startsWith("/") ? file : "/images/dashboard/new-ios/".concat(file)
    });
const EXTREME_UPGRADE_GROUPS = [
    {
        titleKey: "Messages & Calls",
        items: [
            icon("Text Messages", "imessagers.png"),
            icon("Calls", "calls.svg"),
            icon("Voicemail", "voicemail.svg"),
            icon("FaceTime", "facetime.svg")
        ]
    },
    {
        titleKey: "Social & Chat",
        items: [
            icon("WhatsApp", "whatsapp.svg"),
            icon("WA Business", "whatappbusiness.svg"),
            icon("LINE", "line.svg"),
            icon("Kik", "kik.svg"),
            icon("WeChat", "wechat.svg"),
            icon("Teams", "teams.svg"),
            icon("Messenger", "facebookmessage.svg"),
            icon("Telegram", "telegram.svg"),
            icon("Snapchat", "snapchat.svg"),
            icon("Instagram", "instagram.svg"),
            icon("Skype", "skype.svg")
        ]
    },
    {
        titleKey: "System & Web",
        items: [
            icon("Browser History", "browsing.png"),
            icon("Browser Bookmarks", "bookmark.svg"),
            icon("Installed Apps", "installed-app.svg"),
            icon("Wi-Fi Networks", "wifi.svg")
        ]
    }
];
const EXTREME_UPGRADE_FLAT_ICONS = EXTREME_UPGRADE_GROUPS.flatMap((group)=>group.items);

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 4 modules
var message = __webpack_require__(2453);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 27 modules
var modal = __webpack_require__(60770);
// EXTERNAL MODULE: ./src/@api/dashboard.js
var dashboard = __webpack_require__(95629);
// EXTERNAL MODULE: ./src/utils/resolveUpgradeDeviceId.js
var resolveUpgradeDeviceId = __webpack_require__(43756);
// EXTERNAL MODULE: ./src/utils/refreshSubscriptionExpire.js
var refreshSubscriptionExpire = __webpack_require__(49354);
// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
// EXTERNAL MODULE: ./src/components/Message/index.js + 1 modules
var Message = __webpack_require__(29143);
// EXTERNAL MODULE: ./src/utils/navigate.js
var utils_navigate = __webpack_require__(48551);
;// CONCATENATED MODULE: ./src/@core/components/modal/extreme/index.js















const defaultPaymentInfo = {
    card: null,
    planText: " -1-month ",
    expireTime: "2099-12-31",
    price: 49.98,
    upgradePrice: 44.98,
    renewPrice: 99.96
};
const ExtremeModal = (param)=>{
    let { extremeOpen , setExtremeOpen , zIndex =1200  } = param;
    const { t , locale  } = (0,i18n/* useTranslation */.$G)("common");
    const dispatch = (0,es/* useDispatch */.I0)();
    const [messageApi, contextHolder] = message/* default.useMessage */.ZP.useMessage({
        prefixCls: "my-message"
    });
    const [mounted, setMounted] = (0,react.useState)(false);
    const selectedDeviceId = (0,es/* useSelector */.v9)((state)=>state.Common.deviceUser);
    const [deviceId, setDeviceId] = (0,react.useState)(null);
    const [checkID, setCheckID] = (0,react.useState)(1);
    const [tipsOpen, setTipsOpen] = (0,react.useState)(false);
    const [paymentInfo, setPaymentInfo] = (0,react.useState)(defaultPaymentInfo);
    const [confirming, setConfirming] = (0,react.useState)(false);
    const confirmInFlightRef = (0,react.useRef)(false);
    const handlerPlanText = (name)=>{
        const match = name.match(/\d+/g);
        const months = match ? Number(match[0]) : 1;
        return months >= 3 ? " -".concat(months, "-").concat(t("months"), " ") : " -".concat(months, "-").concat(t("month"), " ");
    };
    const fatchPaymentInfo = async (id)=>{
        if (!id) {
            setPaymentInfo(defaultPaymentInfo);
            setCheckID(1);
            return;
        }
        try {
            const result = await (0,dashboard/* getPaymentInfo */.q3)({
                params: {
                    id
                }
            });
            const data = result.data;
            if (data) {
                const card = typeof data.card === "string" ? data.card.trim() : "";
                setPaymentInfo({
                    card: card || null,
                    planText: handlerPlanText(data.name),
                    expireTime: dayjs_min_default()().add(Number(data.valid_days), "day").format("YYYY-MM-DD"),
                    price: Math.ceil((Number(data.price) + Number(data.setup)) / 0.9 * 100) / 100,
                    upgradePrice: Math.ceil((Number(data.price) + Number(data.setup)) * 100) / 100,
                    renewPrice: data.renew_price
                });
                setCheckID(card ? 0 : 1);
            }
        } catch (e) {
            setPaymentInfo(defaultPaymentInfo);
            setCheckID(1);
            ;
        }
    };
    (0,react.useEffect)(()=>{
        setMounted(true);
    }, []);
    (0,react.useEffect)(()=>{
        if (!extremeOpen) return;
        const id = (0,resolveUpgradeDeviceId/* resolveUpgradeDeviceId */.C7)(selectedDeviceId);
        setDeviceId(id);
        fatchPaymentInfo(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        extremeOpen,
        selectedDeviceId
    ]);
    const getCheckoutHref = function() {
        let id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : deviceId;
        const currentId = id !== null && id !== void 0 ? id : (0,resolveUpgradeDeviceId/* resolveUpgradeDeviceId */.C7)(selectedDeviceId);
        const lang = !locale || locale === "" ? "en" : locale === "it-ch" ? "it" : locale;
        const clientUrl = ("https://test-ms-web.gbyte.com.cn" || 0).replace(/\/$/, "");
        return lang === "en" ? "".concat(clientUrl, "/payment-2?id=").concat(currentId) : "".concat(clientUrl, "/").concat(lang, "/payment-2?id=").concat(currentId);
    };
    const onClickAddPayment = ()=>{
        const id = (0,resolveUpgradeDeviceId/* resolveUpgradeDeviceId */.C7)(selectedDeviceId);
        if (!id) {
            (0,Message/* messageInfo */.B)("Current device is missing");
            return;
        }
        setDeviceId(id);
        setCheckID(1);
        (0,utils_navigate/* navigateTo */.T8)(getCheckoutHref(id));
    };
    const onClickConfirm = async ()=>{
        // Guard synchronously so rapid pointer events cannot start two payments
        // before React has committed the disabled state.
        if (confirmInFlightRef.current) return;
        confirmInFlightRef.current = true;
        try {
            const id = (0,resolveUpgradeDeviceId/* resolveUpgradeDeviceId */.C7)(selectedDeviceId);
            if (!id) {
                (0,Message/* messageInfo */.B)("Current device is missing");
                return;
            }
            setDeviceId(id);
            if (checkID === 1 || !paymentInfo.card) {
                (0,utils_navigate/* navigateTo */.T8)(getCheckoutHref(id));
                return;
            }
            setConfirming(true);
            const result = await (0,dashboard/* upgradePayment */.LF)({
                id
            });
            if (Number(result.code) === 0) {
                await (0,refreshSubscriptionExpire/* refreshSubscriptionExpire */.Af)({
                    dispatch
                });
                dispatch((0,Common/* changeExtremeService */.xU)(true));
                // spyx 对齐：先 USER_SUMMARY 预缓冲，再广播让本页拉详情读 advanced
                await (0,extremeUpgrade/* notifyExtremeUpgraded */.NC)();
                setExtremeOpen(false);
                messageApi.success(result.msg || "Upgrade successful");
            } else {
                (0,Message/* messageInfo */.B)((result === null || result === void 0 ? void 0 : result.msg) || "Upgrade failed", 6);
            }
        } catch (e) {
            var ref, ref1;
            const errMsg = (e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.msg) || (e === null || e === void 0 ? void 0 : e.msg) || (e === null || e === void 0 ? void 0 : e.message) || "Upgrade failed";
            (0,Message/* messageInfo */.B)(errMsg, 6);
            ;
        } finally{
            setConfirming(false);
            confirmInFlightRef.current = false;
        }
    };
    const cardDisplay = paymentInfo.card ? paymentInfo.card.includes("*") ? paymentInfo.card : "**** **** **** ".concat(paymentInfo.card.slice(-4)) : "**** **** **** ****";
    const paymentOptionClass = (selected)=>"flex w-full cursor-pointer items-center rounded-[8px] border border-solid bg-white p-[10px] ".concat(selected ? "border-[#4A77FE]" : "border-[#E9EFF3] hover:border-[#C8D5FF]");
    const overlay = extremeOpen && mounted ? /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed bottom-0 right-0 top-[60px] flex items-center justify-center overflow-y-auto bg-[rgba(0,0,0,0.5)] px-4 py-6 smj:left-0 smj:items-start smj:px-4 smj:py-8 smjs:left-[300px]",
        style: {
            zIndex
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative my-auto flex w-full max-w-[544px] flex-col items-center gap-8 overflow-hidden rounded-[16px] bg-gradient-to-b from-white to-[#E8F4FF] p-8 shadow-[0px_20px_30px_0px_rgba(40,41,56,0.3)] smj:max-h-[min(710px,calc(100vh-64px))] smj:max-w-[calc(100vw-32px)] smj:overflow-y-auto smj:p-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    "aria-label": "close",
                    className: "absolute right-3 top-3 z-[1] flex size-6 items-center justify-center",
                    onClick: ()=>setExtremeOpen(false),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "relative block size-[16px]",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute left-1/2 top-1/2 block h-5 w-0.5 -translate-x-1/2 -translate-y-1/2 rotate-45 rounded-[4px] bg-[#9297AF]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute left-1/2 top-1/2 block h-5 w-0.5 -translate-x-1/2 -translate-y-1/2 -rotate-45 rounded-[4px] bg-[#9297AF]"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "w-full text-center text-[24px] font-semibold leading-9 text-[#020417] smj:text-[20px] smj:leading-7",
                    children: t("Choose your payment method")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full flex-col gap-4",
                    children: [
                        paymentInfo.card ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: paymentOptionClass(checkID === 0),
                            onClick: ()=>{
                                setCheckID(0);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "flex items-center gap-2.5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/extreme/card.webp",
                                        alt: "",
                                        width: 24,
                                        height: 24,
                                        className: "shrink-0 !h-6 !w-6"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[14px] font-medium leading-[18px] text-[#4A77FE]",
                                        children: cardDisplay
                                    })
                                ]
                            })
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: paymentOptionClass(checkID === 1),
                            onClick: onClickAddPayment,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "flex min-w-0 items-center gap-2.5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/extreme/add-unit.svg",
                                        alt: "",
                                        width: 24,
                                        height: 24,
                                        className: "shrink-0 !h-6 !w-6"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "min-w-0 text-[14px] font-normal leading-[18px] text-[#020417]",
                                        children: t("Add another card or payment method")
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: "text-[18px] font-medium leading-[26px] text-[#020417]",
                            children: [
                                t("Order details"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full flex-col gap-2.5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-end justify-between gap-3 text-[14px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "shrink-0 leading-5 text-[#6B6F88]",
                                            children: [
                                                t("Youre getting"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "text-right leading-[18px] text-[#020417]",
                                            children: [
                                                t("Upgrade to"),
                                                "\xa0Extreme"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start justify-between gap-3 text-[14px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "shrink-0 leading-5 text-[#6B6F88]",
                                            children: [
                                                t("You Plan"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "text-right leading-[18px] text-[#020417]",
                                            children: [
                                                t("Msafely"),
                                                "\xa0Extreme",
                                                paymentInfo.planText,
                                                t("Subscription")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between gap-3 text-[14px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "flex shrink-0 items-center leading-5 text-[#6B6F88]",
                                            children: [
                                                t("Expire Time"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    className: "mx-1 inline-flex size-3 shrink-0 items-center justify-center",
                                                    onClick: ()=>setTipsOpen(true),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/extreme/question.svg",
                                                        alt: "",
                                                        width: 12,
                                                        height: 12,
                                                        className: "!h-3 !w-3"
                                                    })
                                                }),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-right leading-[18px] text-[#020417]",
                                            children: paymentInfo.expireTime
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between gap-3 text-[14px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "shrink-0 leading-5 text-[#6B6F88]",
                                            children: [
                                                t("Upgrade price"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-start gap-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/extreme/save10.webp",
                                                    alt: "",
                                                    width: 60,
                                                    height: 20,
                                                    className: "!h-5 !w-[60px] shrink-0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "whitespace-nowrap text-right text-[14px] leading-[21px] text-[#020417]",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "text-[#353746] line-through",
                                                            children: [
                                                                "$",
                                                                paymentInfo.price
                                                            ]
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "font-medium",
                                                            children: [
                                                                "$",
                                                                paymentInfo.upgradePrice
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full items-start justify-center gap-4 font-medium smj:flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "flex h-10 w-[240px] items-center justify-center rounded-[40px] border border-solid border-[#454CFF] bg-transparent px-10 text-[14px] leading-5 text-[#454CFF] smj:order-1 smj:w-full",
                            onClick: ()=>setExtremeOpen(false),
                            children: t("Cancel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            disabled: confirming,
                            className: "flex h-10 w-[240px] items-center justify-center rounded-[40px] bg-[#FFCF55] px-10 text-[14px] leading-5 text-[#020417] disabled:cursor-not-allowed disabled:opacity-70 smj:order-0 smj:w-full",
                            onClick: onClickConfirm,
                            children: confirming ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                size: "small"
                            }) : t("Confirm")
                        })
                    ]
                })
            ]
        })
    }), document.body) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            contextHolder,
            overlay,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* default */.Z, {
                open: tipsOpen,
                centered: true,
                closable: false,
                footer: null,
                width: "min(335px, calc(100vw - 32px))",
                zIndex: zIndex + 100,
                styles: {
                    content: {
                        padding: "0px",
                        borderRadius: "4px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative h-[38px] [border-bottom:1px_solid_#E6E6E6]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/extreme/extreme-close.svg",
                            alt: "extreme-close",
                            width: 16,
                            height: 16,
                            className: "absolute right-3 top-3 !h-4 !w-4 cursor-pointer",
                            onClick: ()=>setTipsOpen(false)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        className: "flex flex-col gap-y-[10px] p-3 text-[13px] font-normal leading-[18px] text-[#222222]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    t("Your subscription date will be recalculated from the day of the upgrade so your subscription will be renewed on"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[#2A99FF]",
                                        children: paymentInfo.expireTime
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    t("Your renewal price will be the sum of the Basic plan and the Extreme plan so your renewal price will be"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-[#2A99FF]",
                                        children: [
                                            "$",
                                            paymentInfo.renewPrice
                                        ]
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var extreme = (ExtremeModal);

;// CONCATENATED MODULE: ./src/@core/components/modal/extreme-upgrade/useExtremeUpgradePayment.js











const useExtremeUpgradePayment_defaultPaymentInfo = {
    card: null,
    months: 1,
    price: 49.98,
    upgradePrice: 44.98
};
const parseMonths = (name)=>{
    const match = typeof name === "string" ? name.match(/\d+/g) : null;
    return match ? Number(match[0]) : 1;
};
/** 月均价：向下取整到 2 位小数（不用四舍五入） */ const formatMoney = (value)=>{
    const n = Number(value);
    if (!Number.isFinite(n)) return "0.00";
    return (Math.floor(n * 100 + Number.EPSILON) / 100).toFixed(2);
};
const useExtremeUpgradePayment = (param)=>{
    let { enabled , onPaymentFallback  } = param;
    const { locale  } = (0,i18n/* useTranslation */.$G)("common");
    const dispatch = (0,es/* useDispatch */.I0)();
    const [messageApi, contextHolder] = message/* default.useMessage */.ZP.useMessage();
    const selectedDeviceId = (0,es/* useSelector */.v9)((state)=>state.Common.deviceUser);
    const [paymentInfo, setPaymentInfo] = (0,react.useState)(useExtremeUpgradePayment_defaultPaymentInfo);
    const [loading, setLoading] = (0,react.useState)(false);
    const [paying, setPaying] = (0,react.useState)(false);
    const fetchPaymentInfo = (0,react.useCallback)(async ()=>{
        const id = (0,resolveUpgradeDeviceId/* resolveUpgradeDeviceId */.C7)(selectedDeviceId);
        if (!id) {
            setPaymentInfo(useExtremeUpgradePayment_defaultPaymentInfo);
            return;
        }
        setLoading(true);
        try {
            const result = await (0,dashboard/* getPaymentInfo */.q3)({
                params: {
                    id
                }
            });
            const data = result.data;
            if (data) {
                const card = typeof data.card === "string" ? data.card.trim() : "";
                const months = parseMonths(data.name);
                const upgradePrice = Math.ceil((Number(data.price) + Number(data.setup)) * 100) / 100;
                const price = Math.ceil((Number(data.price) + Number(data.setup)) / 0.9 * 100) / 100;
                setPaymentInfo({
                    card: card || null,
                    months,
                    price,
                    upgradePrice,
                    expireTime: dayjs_min_default()().add(Number(data.valid_days), "day").format("YYYY-MM-DD")
                });
            }
        } catch (error) {
            setPaymentInfo(useExtremeUpgradePayment_defaultPaymentInfo);
            ;
        } finally{
            setLoading(false);
        }
    }, [
        selectedDeviceId
    ]);
    (0,react.useEffect)(()=>{
        if (!enabled) return;
        fetchPaymentInfo();
    }, [
        enabled,
        fetchPaymentInfo
    ]);
    const getCheckoutHref = (0,react.useCallback)((id)=>{
        const currentId = id !== null && id !== void 0 ? id : (0,resolveUpgradeDeviceId/* resolveUpgradeDeviceId */.C7)(selectedDeviceId);
        const lang = !locale || locale === "" ? "en" : locale === "it-ch" ? "it" : locale;
        const clientUrl = ("https://test-ms-web.gbyte.com.cn" || 0).replace(/\/$/, "");
        return lang === "en" ? "".concat(clientUrl, "/payment-2?id=").concat(currentId) : "".concat(clientUrl, "/").concat(lang, "/payment-2?id=").concat(currentId);
    }, [
        locale,
        selectedDeviceId
    ]);
    const pricing = (0,react.useMemo)(()=>{
        const months = paymentInfo.months || 1;
        const monthlyDiscounted = formatMoney(paymentInfo.upgradePrice / months);
        const monthlyOriginal = formatMoney(paymentInfo.price / months);
        return {
            months,
            monthlyDiscounted,
            monthlyOriginal
        };
    }, [
        paymentInfo
    ]);
    const handleUnlock = async ()=>{
        const id = (0,resolveUpgradeDeviceId/* resolveUpgradeDeviceId */.C7)(selectedDeviceId);
        if (!id) {
            messageApi.error("Current device is missing");
            return;
        }
        if (!paymentInfo.card) {
            (0,utils_navigate/* navigateTo */.T8)(getCheckoutHref(id));
            return;
        }
        setPaying(true);
        try {
            const result = await (0,dashboard/* upgradePayment */.LF)({
                id
            });
            if (Number(result.code) === 0) {
                await (0,refreshSubscriptionExpire/* refreshSubscriptionExpire */.Af)({
                    dispatch
                });
                dispatch((0,Common/* changeExtremeService */.xU)(true));
                // spyx 对齐：先 USER_SUMMARY 预缓冲，再广播让本页拉详情读 advanced
                await (0,extremeUpgrade/* notifyExtremeUpgraded */.NC)();
                messageApi.success(result.msg || "Upgrade successful");
            } else {
                onPaymentFallback === null || onPaymentFallback === void 0 ? void 0 : onPaymentFallback();
            }
        } catch (error) {
            ;
            onPaymentFallback === null || onPaymentFallback === void 0 ? void 0 : onPaymentFallback();
        } finally{
            setPaying(false);
        }
    };
    return {
        contextHolder,
        handleUnlock,
        loading,
        paying,
        paymentInfo,
        pricing
    };
};
/* harmony default export */ var extreme_upgrade_useExtremeUpgradePayment = (useExtremeUpgradePayment);

;// CONCATENATED MODULE: ./src/@core/components/modal/extreme-upgrade/ExtremeUpgradeModal.js












const chunkIcons = (items, size)=>{
    const rows = [];
    for(let i = 0; i < items.length; i += size){
        rows.push(items.slice(i, i + size));
    }
    return rows;
};
const SupportIcon = (param)=>/*#__PURE__*/ {
    let { item , compact =false  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: compact ? "flex size-10 shrink-0 items-center justify-center" : "flex w-[103px] flex-col items-center gap-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative overflow-hidden ".concat(compact ? "size-10 rounded-[10px]" : "size-12 rounded-[12px]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: item.img,
                    alt: item.name,
                    fill: true,
                    className: "object-contain",
                    sizes: compact ? "40px" : "48px"
                })
            }),
            compact ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "w-full text-center text-[14px] leading-5 text-[#353746]",
                children: item.name
            })
        ]
    });
};
const HeroCopy = (param)=>{
    let { titleClass , subtitleWrapClass =""  } = param;
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative z-[1] flex flex-col items-center gap-2.5 ".concat(subtitleWrapClass),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: titleClass,
                children: t("Upgrade to Extreme Plan")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-center text-[14px] leading-5 text-[#E8EDFF]",
                children: [
                    t("Unlock 19 advanced monitoring features and full"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "inline-flex items-center gap-1 text-[16px] font-medium leading-6 text-white",
                        children: [
                            t("iOS 26 support"),
                            ".",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/extreme-upgrade/ios26-apple.svg",
                                alt: "",
                                width: 16,
                                height: 18,
                                className: "h-[18px] w-4"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const PcHero = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex h-[122px] items-center justify-center overflow-hidden rounded-[16px] px-8 py-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/images/extreme-upgrade/hero-bg.svg",
                alt: "",
                fill: true,
                priority: true,
                sizes: "720px",
                className: "pointer-events-none object-cover"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroCopy, {
                titleClass: "text-[24px] font-semibold leading-9 text-white"
            })
        ]
    });
const MobileHero = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative overflow-hidden rounded-[12px] p-2.5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/images/extreme-upgrade/hero-bg-mobile.svg",
                alt: "",
                fill: true,
                sizes: "(max-width: 990px) calc(100vw - 32px), 331px",
                className: "pointer-events-none object-cover"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroCopy, {
                titleClass: "text-[20px] font-semibold leading-7 text-white",
                subtitleWrapClass: "w-full"
            })
        ]
    });
const ExtremeUpgradeModal = (param)=>{
    let { open , onClose  } = param;
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    const selectedDeviceId = (0,es/* useSelector */.v9)((state)=>state.Common.deviceUser);
    const deviceSwitchRevision = (0,es/* useSelector */.v9)((state)=>state.Common.deviceSwitchRevision);
    const [mounted, setMounted] = (0,react.useState)(false);
    const [paidClosed, setPaidClosed] = (0,react.useState)(false);
    const [paymentFallbackOpen, setPaymentFallbackOpen] = (0,react.useState)(false);
    const [expiredBlocksUpgrade, setExpiredBlocksUpgrade] = (0,react.useState)(false);
    const { contextHolder , handleUnlock , loading , paying  } = extreme_upgrade_useExtremeUpgradePayment({
        enabled: open && !paidClosed && !expiredBlocksUpgrade,
        onPaymentFallback: ()=>setPaymentFallbackOpen(true)
    });
    const prevDeviceIdRef = (0,react.useRef)(selectedDeviceId);
    (0,react.useEffect)(()=>{
        setMounted(true);
    }, []);
    // 宽限期过期续费优先：过期时不展示升级弹窗
    (0,react.useEffect)(()=>{
        try {
            const deviceUser = JSON.parse(localStorage.getItem("DeviceUser") || "null");
            setExpiredBlocksUpgrade((0,subscriptionStatus/* isGraceDevice */.cw)(deviceUser));
        } catch (e) {
            setExpiredBlocksUpgrade(false);
        }
    }, [
        selectedDeviceId,
        deviceSwitchRevision,
        open
    ]);
    (0,react.useEffect)(()=>{
        if (!open) {
            setPaidClosed(false);
            setPaymentFallbackOpen(false);
        }
    }, [
        open
    ]);
    (0,react.useEffect)(()=>{
        if (prevDeviceIdRef.current === selectedDeviceId) return;
        prevDeviceIdRef.current = selectedDeviceId;
        setPaidClosed(false);
        setPaymentFallbackOpen(false);
    }, [
        selectedDeviceId
    ]);
    (0,react.useEffect)(()=>{
        const closeAfterPaid = ()=>{
            setPaidClosed(true);
            setPaymentFallbackOpen(false);
        };
        window.addEventListener(extremeUpgrade/* EXTREME_UPGRADED_EVENT */.zp, closeAfterPaid);
        return ()=>window.removeEventListener(extremeUpgrade/* EXTREME_UPGRADED_EVENT */.zp, closeAfterPaid);
    }, []);
    if (!open || !mounted || expiredBlocksUpgrade) return null;
    const overlay = /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed bottom-0 right-0 top-[60px] z-[1200] flex items-center justify-center overflow-y-auto bg-[rgba(0,0,0,0.5)] px-4 py-4 smj:left-0 smj:items-start smj:px-4 smj:pb-4 smj:pt-3 smjs:left-[300px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative my-auto w-full max-w-[786px] rounded-[16px] bg-gradient-to-b from-white to-[#E8F4FF] p-8 shadow-[0px_6px_20px_0px_rgba(40,41,56,0.15)] smj:my-0 smj:max-h-[calc(100dvh-60px-28px)] smj:overflow-y-auto smj:px-4 smj:py-6",
            children: [
                onClose ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    "aria-label": "Close",
                    onClick: onClose,
                    className: "absolute right-3 top-3 z-10 flex size-7 items-center justify-center rounded-full bg-[#020417] text-[16px] leading-none text-white transition-opacity hover:opacity-80",
                    children: "\xd7"
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center gap-8 smj:gap-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full flex-col gap-6 smj:gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "smj:hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PcHero, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden smj:block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileHero, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center gap-1.5",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-[20px] font-semibold leading-7 text-[#020417] smj:text-[18px] smj:font-medium smj:leading-[26px]",
                                                    children: t("Support")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "hidden items-center gap-1.5 smj:flex",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "rounded-[6px] bg-[rgba(70,125,255,0.2)] px-2.5 text-[10px] leading-[18px] text-[#467dff]",
                                                            children: t("19 types")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "rounded-[6px] bg-[rgba(70,125,255,0.2)] px-2.5 text-[10px] leading-[18px] text-[#467dff]",
                                                            children: t("iOS26")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "smj:hidden",
                                            children: EXTREME_UPGRADE_GROUPS.map((group)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-4 last:mb-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mb-2.5 text-[16px] font-medium leading-6 text-[#020417]/80",
                                                            children: t(group.titleKey)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "flex flex-wrap gap-x-4 gap-y-2.5",
                                                            children: group.items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SupportIcon, {
                                                                    item: item
                                                                }, item.name))
                                                        })
                                                    ]
                                                }, group.titleKey))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hidden w-full flex-col gap-4 smj:flex",
                                            children: chunkIcons(EXTREME_UPGRADE_FLAT_ICONS, 5).map((row)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex w-full items-start justify-between",
                                                    children: [
                                                        row.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SupportIcon, {
                                                                item: item,
                                                                compact: true
                                                            }, item.name)),
                                                        row.length < 5 ? Array.from({
                                                            length: 5 - row.length
                                                        }).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "size-10 shrink-0",
                                                                "aria-hidden": true
                                                            }, "spacer-".concat(index))) : null
                                                    ]
                                                }, row.map((item)=>item.name).join("-")))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            disabled: paying || loading,
                            className: "relative mx-auto flex h-10 w-[240px] items-center justify-center rounded-[40px] bg-[#FFCF55] px-10 font-[Poppins] text-[14px] font-medium leading-5 tracking-normal text-[#020417] disabled:cursor-not-allowed disabled:opacity-70 smj:w-full",
                            onClick: handleUnlock,
                            children: [
                                paying ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                    size: "small"
                                }) : t("Unlock All Data"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pointer-events-none absolute -right-2 -top-[14px] box-border flex h-[29px] min-w-16 items-start justify-center whitespace-nowrap px-2.5 pt-1 text-center text-[12px] font-semibold uppercase leading-4 text-white smj:hidden",
                                    style: {
                                        backgroundImage: "url('/images/extreme-upgrade/cta-10-off-badge.svg')",
                                        backgroundSize: "100% 100%",
                                        backgroundRepeat: "no-repeat"
                                    },
                                    children: t("10% off")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }), document.body);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            contextHolder,
            paidClosed ? null : overlay,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(extreme, {
                extremeOpen: paymentFallbackOpen && !paidClosed,
                setExtremeOpen: setPaymentFallbackOpen,
                zIndex: 1300
            })
        ]
    });
};
/* harmony default export */ var extreme_upgrade_ExtremeUpgradeModal = (ExtremeUpgradeModal);

;// CONCATENATED MODULE: ./src/@core/components/modal/extreme-upgrade/index.js




/***/ }),

/***/ 76919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NC": function() { return /* binding */ notifyExtremeUpgraded; },
/* harmony export */   "ti": function() { return /* binding */ primeExtremeAdvancedCache; },
/* harmony export */   "zp": function() { return /* binding */ EXTREME_UPGRADED_EVENT; }
/* harmony export */ });
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95629);

/**
 * Extreme 升级成功后的跨页面通知。
 *
 * 背景：升级弹窗 ExtremeModal 与各功能页（text / calls / whatsapp…）解耦，
 * 扣款成功后必须先预缓冲 advanced，再广播事件让各页重拉详情读 advance。
 * 对齐 spyx：USER_SUMMARY 预缓冲 → 当前页业务接口看 advanced。
 */ const EXTREME_UPGRADED_EVENT = "extreme-upgraded";
/**
 * 升级后预热 advanced 状态（必须先于各功能页自己的查询）。
 *
 * 后端为节省流量：首次查询先返回缓存，同时在后台检查/同步 advanced；
 * 同步完成后，**下一次**业务查询才会返回最新 advanced。
 *
 * POST /api/dashboard/auth/all（category: USER_SUMMARY）会触发后台 advanced 同步，
 * 因此各页在拉 smsChat-summary / CALL 等接口前，必须先 await 本函数。
 *
 * @returns {Promise<void>}
 */ async function primeExtremeAdvancedCache() {
    var ref;
    if (false) {}
    const mode = localStorage.getItem("currentMode") || "iOS-Cloud";
    if (mode !== "iOS-Cloud") return;
    const username = (ref = JSON.parse(localStorage.getItem("DeviceUser") || "{}")) === null || ref === void 0 ? void 0 : ref.username;
    if (!username) return;
    try {
        await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_0__/* .getAllDashboard */ .gP)({
            username,
            params: {
                category: "USER_SUMMARY"
            }
        });
    } catch (e) {
        ;
    }
}
/**
 * 升级扣款成功后调用：先 USER_SUMMARY 预缓冲，再通知当前已挂载功能页重拉详情。
 * 调用方须 await，保证预缓冲完成后再关弹窗 / 刷新 UI。
 */ const notifyExtremeUpgraded = async ()=>{
    if (false) {}
    await primeExtremeAdvancedCache();
    window.dispatchEvent(new CustomEvent(EXTREME_UPGRADED_EVENT));
};


/***/ }),

/***/ 49354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Af": function() { return /* binding */ refreshSubscriptionExpire; },
/* harmony export */   "Vk": function() { return /* binding */ RENEW_SUCCESS_REFRESH_DELAY; },
/* harmony export */   "dZ": function() { return /* binding */ reloadAfterRenewSuccess; },
/* harmony export */   "pG": function() { return /* binding */ matchCurrentDevice; }
/* harmony export */ });
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34745);


const readDeviceUser = ()=>{
    try {
        return JSON.parse(localStorage.getItem("DeviceUser") || "{}") || {};
    } catch (e) {
        return {};
    }
};
/**
 * 在设备列表里定位当前设备（先按 device_id，再按 iCloud_username）。
 * 供「需要按设备接口判定平台类型」的页面复用。
 * @param {Array} list - user-device 接口返回的设备数组
 * @param {Object} deviceUser - localStorage DeviceUser 对象
 * @returns {Object|null}
 */ const matchCurrentDevice = (list, deviceUser)=>{
    const devices = Array.isArray(list) ? list : [];
    const deviceId = deviceUser === null || deviceUser === void 0 ? void 0 : deviceUser.device_id;
    const username = deviceUser === null || deviceUser === void 0 ? void 0 : deviceUser.username;
    if (deviceId != null && deviceId !== "") {
        const byId = devices.find((item)=>String(item.id) === String(deviceId) || String(item.device_id) === String(deviceId));
        if (byId) return byId;
    }
    if (username) {
        return devices.find((item)=>item.iCloud_username === username) || null;
    }
    return null;
};
/**
 * 续费 / 升级成功后无感刷新：
 * 1. 重拉设备列表写入 allDeviceUser
 * 2. 同步当前 DeviceUser.expire_time
 * 3. bump deviceSwitchRevision，驱动侧栏 / ExpiredMask 重算
 *
 * @param {Object} [params]
 * @param {import('redux').Dispatch} [params.dispatch]
 * @param {string} [params.expireTime] - 接口已返回的新到期时间，优先写入
 * @returns {Promise<{ ok: boolean, expireTime: string|null, device: Object|null }>}
 */ const refreshSubscriptionExpire = async function() {
    let { dispatch , expireTime  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (false) {}
    const prevDeviceUser = readDeviceUser();
    let devices = [];
    try {
        const res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getAllUserDevice)({});
        devices = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
        localStorage.setItem("allDeviceUser", JSON.stringify(devices));
    } catch (e) {
        ;
    }
    const matched = matchCurrentDevice(devices, prevDeviceUser);
    const nextExpire = expireTime || (matched === null || matched === void 0 ? void 0 : matched.expire_time) || (prevDeviceUser === null || prevDeviceUser === void 0 ? void 0 : prevDeviceUser.expire_time) || null;
    var _iCloud_username, _temporary, _order_id, ref, ref1, _subscription_status, ref2;
    const nextDeviceUser = {
        ...prevDeviceUser,
        ...matched ? {
            username: (_iCloud_username = matched.iCloud_username) !== null && _iCloud_username !== void 0 ? _iCloud_username : prevDeviceUser.username,
            temporary: (_temporary = matched.temporary) !== null && _temporary !== void 0 ? _temporary : prevDeviceUser.temporary,
            device_id: matched.id || matched.device_id || prevDeviceUser.device_id || "",
            order_id: (ref1 = (ref = (_order_id = matched.order_id) !== null && _order_id !== void 0 ? _order_id : matched.orderId) !== null && ref !== void 0 ? ref : prevDeviceUser.order_id) !== null && ref1 !== void 0 ? ref1 : null,
            subscription_status: (ref2 = (_subscription_status = matched.subscription_status) !== null && _subscription_status !== void 0 ? _subscription_status : prevDeviceUser.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
        } : {},
        ...nextExpire ? {
            expire_time: nextExpire
        } : {}
    };
    localStorage.setItem("DeviceUser", JSON.stringify(nextDeviceUser));
    if (typeof dispatch === "function") {
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__/* .subscriptionRefreshed */ .Hw)());
    }
    return {
        ok: true,
        expireTime: nextExpire,
        device: matched
    };
};
/** 站内直接续费成功后延时整页刷新；软同步覆盖不全（banner / 遮罩仍可能停在已过期） */ const RENEW_SUCCESS_REFRESH_DELAY = 1500;
const reloadAfterRenewSuccess = function() {
    let delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : RENEW_SUCCESS_REFRESH_DELAY;
    if (false) {}
    window.setTimeout(()=>window.location.reload(), delay);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (refreshSubscriptionExpire)));


/***/ })

}]);